<script setup lang="ts">
import type { SelectOption } from '@camelot/components'
import { CtSelect } from '@camelot/components'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { ExternalControllerApi } from '~/api/prebooking'
import AddressSelection from '~/components/input/location/AddressSelection.vue'
import type { City } from '~/composables/city'
import { SORTED_CITIES_AS_SELECT_OPTIONS } from '~/composables/city'
import { translate } from '~/composables/translate/translations'
import { useLocationStore } from '~/stores/location'

const locationStore = useLocationStore()
const { city } = storeToRefs(locationStore)

const cities = ref<SelectOption[]>(SORTED_CITIES_AS_SELECT_OPTIONS)

onBeforeMount(() => {
  if (import.meta.env.NODE_ENV === 'production') {
    new ExternalControllerApi().getLocationDevelopmentState().then((locationDevStatus) => {
      cities.value = SORTED_CITIES_AS_SELECT_OPTIONS.filter((cityOpt) => {
        const city = cityOpt.value as City
        const status = locationDevStatus.find(loc => loc.locationId === city.locationId)
        return status ? !status.isDevelopment : false
      })
    })
  }
})
</script>

<template>
  <article>
    <h3 class="text-black-100">
      {{ translate('headline_where') }}
    </h3>

    <form class="flex flex-col md:flex-row mt-20">
      <CtSelect
        v-model="city"
        :label="translate('field_label_city')"
        :options="cities"
        data-testid="select-city"
        :placeholder="translate('placeholder_address')"
        class="md:basis-[35%] md:flex-none"
      />
      <AddressSelection class="md:ml-[10px] xs:mt-20 md:mt-0" />
    </form>
  </article>
</template>
